import Loader from './loader';

export default class Button extends Loader {

	static defaults = {
		template: '<div class="bx-yapay-skeleton-loading"><div class="bx-yapay-skeleton-load"></div></div>',
	}
}
